import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AppProvider, useApp } from "./contexts/AppContext";
import { BrandingProvider } from "./contexts/BrandingContext";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import ProviderApp from "./pages/ProviderApp";

const ProviderRoute = ({ children }) => {
  const { currentUser, currentUserType } = useApp();
  if (!currentUser) return <Navigate to="/login" replace />;
  if (currentUserType !== "provider")
    return <Navigate to="/dashboard" replace />;
  return children;
};

const NonProviderRoute = ({ children }) => {
  const { currentUser, currentUserType } = useApp();
  if (!currentUser) return <Navigate to="/login" replace />;
  if (currentUserType === "provider")
    return <Navigate to="/provider/earnings" replace />;
  return children;
};

const homePath = (role) =>
  role === "provider" ? "/provider/earnings" : "/dashboard";

function AppRoutes() {
  const { currentUser, currentUserType, authChecked } = useApp();

  if (!authChecked) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <span className="spinner" aria-label="Loading" />
      </div>
    );
  }

  return (
    <Routes>
      <Route
        path="/login"
        element={
          currentUser ? (
            <Navigate to={homePath(currentUserType)} replace />
          ) : (
            <Login />
          )
        }
      />
      <Route
        path="/dashboard/*"
        element={
          <NonProviderRoute>
            <Dashboard />
          </NonProviderRoute>
        }
      />
      <Route
        path="/provider/*"
        element={
          <ProviderRoute>
            <ProviderApp />
          </ProviderRoute>
        }
      />
      <Route
        path="/"
        element={<Navigate to={homePath(currentUserType)} replace />}
      />
      <Route
        path="*"
        element={<Navigate to={homePath(currentUserType)} replace />}
      />
    </Routes>
  );
}

function App() {
  return (
    <BrandingProvider>
      <BrowserRouter>
        <AppProvider>
          <AppRoutes />
        </AppProvider>
      </BrowserRouter>
    </BrandingProvider>
  );
}

export default App;
